var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`formulate-input-element formulate-input-element--${_vm.context.class}`,attrs:{"data-type":_vm.context.type}},[_c('fishbone-diagram',_vm._b({},'fishbone-diagram',_vm.finalFishboneData,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }